export default __webpack_public_path__ + "static/media/thinkstep.ee3d420c.png";